import React from 'react';
import { ServiceLineItem } from '../../shared/types';

interface ServiceLinesProps {
  serviceLines: ServiceLineItem[];
  onServiceLinesChange: (lines: ServiceLineItem[]) => void;
}

const ServiceLines: React.FC<ServiceLinesProps> = ({ serviceLines, onServiceLinesChange }) => {
  const handleAdd = () => {
    onServiceLinesChange([...serviceLines, { description: '', hours: '', minutes: '' }]);
  };

  const handleRemove = (index: number) => {
    onServiceLinesChange(serviceLines.filter((_, i) => i !== index));
  };

  const handleChange = (index: number, field: keyof ServiceLineItem, value: string) => {
    onServiceLinesChange(
      serviceLines.map((line, i) => (i === index ? { ...line, [field]: value } : line))
    );
  };

  return (
    <div className="section">
      <h2>Service Lines</h2>
      <p style={{ color: '#666', fontSize: '0.9em', margin: '0 0 12px' }}>
        Add a line per service and enter the hours worked for each. Labor is billed at the hourly rate below.
      </p>

      {serviceLines.length === 0 && (
        <p style={{ color: '#999', fontSize: '0.9em', margin: '0 0 12px' }}>No service lines yet.</p>
      )}

      {serviceLines.map((line, index) => (
        <div key={index} className="service-line-item">
          <textarea
            value={line.description}
            onChange={(e) => handleChange(index, 'description', e.target.value)}
            placeholder="Service description"
            rows={2}
            className="service-line-description"
          />
          <div className="service-line-time">
            <div className="time-field">
              <input
                type="number"
                value={line.hours}
                onChange={(e) => handleChange(index, 'hours', e.target.value)}
                placeholder="Hours"
                min="0"
              />
              <span>hrs</span>
            </div>
            <div className="time-field">
              <input
                type="number"
                value={line.minutes}
                onChange={(e) => handleChange(index, 'minutes', e.target.value)}
                placeholder="Minutes"
                min="0"
                max="59"
              />
              <span>min</span>
            </div>
          </div>
          <button
            type="button"
            onClick={() => handleRemove(index)}
            className="remove-cost-btn"
            title="Remove service line"
          >
            ×
          </button>
        </div>
      ))}

      <button type="button" onClick={handleAdd} className="add-cost-btn">
        + Add Service Line
      </button>

      <style>{`
        .service-line-item {
          display: flex;
          gap: 10px;
          margin-bottom: 12px;
          align-items: flex-start;
        }
        .service-line-description {
          flex: 2;
        }
        .service-line-time {
          display: flex;
          gap: 10px;
          flex: 1;
        }
        .service-line-time .time-field {
          display: flex;
          align-items: center;
          gap: 4px;
        }
        .service-line-time .time-field input {
          width: 70px;
        }
      `}</style>
    </div>
  );
};

export default ServiceLines;
